<script setup lang="ts">
import { useModel } from '@kwai-explore/model';
import BaseLayout from '../components/base-layout/BaseLayout.vue';
import CountDown from './components/CountDown.vue';
import { HomeModel } from './model/homeModel';
import CommerceCardList from '@pet/fish.commerce-card-list/index.vue';
import type { CommerceItem } from '@pet/fish.commerce-card-list/types';
import { CardClickArea } from '@pet/fish.commerce-card-list/types';
import { useLogger } from '@/utils/logger';
import { getAdidFromByQuery } from '@/utils';
import { useRoute } from '@pet/base.utils';
import { EntrySRC } from '@/types/e-commerce';
import { useViewDepthLog } from '@/hooks/useViewDepthLog';
import { getChannelFromQuery } from '@/pages/e-commerce/utils/utils';

const { endTime, refreshEndTime, mainTitle, commodityList, gotoOrder, exitPage, showCountDown } = useModel(HomeModel);
const route = useRoute();
const { usePV, sendClickImmediately } = useLogger();
const { updateViewDepthParams } = useViewDepthLog();
const { addParamsToPV } = usePV();
if (!import.meta.env.SSR) {
    addParamsToPV({
        params: {
            activity_name: '5235d9b379e',
            entry_src: EntrySRC.MEDIA_AD, // 暂时表示媒体投放
            // 区分不同的活动通过渠道名映射
            source_channel: getChannelFromQuery(route),
            ug_adid: getAdidFromByQuery(route.query),
        },
    });
}
const handleCardClick = (item: CommerceItem, action: CardClickArea, idx: number) => {
    sendClickImmediately('GOODS_CARD', {
        goods_id: String(item.itemId),
        click_depth: String(idx + 1),
        source_channel: getChannelFromQuery(route),
    });
    gotoOrder(item, action);
};

const handleCardShow = (item: CommerceItem, idx: number) => {
    updateViewDepthParams(idx);
};
</script>
<template>
    <BaseLayout class="base-layout" :main-title="mainTitle" @back="exitPage">
        <CountDown v-if="showCountDown" :end-time="endTime" @finish="refreshEndTime" />
        <div class="placeholder" v-else></div>
        <CommerceCardList class="card-list" :list="commodityList" @click="handleCardClick" @show="handleCardShow" />
    </BaseLayout>
</template>
<style lang="less" scoped>
.base-layout {
    .placeholder {
        margin-top: 12px;
        height: 20px;
    }
    .card-list {
        margin-top: 16px;
        padding-bottom: 48px;
    }
}
</style>
